"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faSearch_1 = require("@fortawesome/pro-regular-svg-icons/faSearch");
var material_1 = require("@mui/material");
var utils_1 = require("@mui/utils");
var react_1 = __importStar(require("react"));
var react_redux_firebase_1 = require("react-redux-firebase");
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var ClearButton_1 = __importDefault(require("atomicComponents/atoms/SearchBar/ClearButton"));
var SmallIcon_1 = __importDefault(require("../atoms/Icons/SmallIcon"));
var SearchInput_1 = __importDefault(require("../atoms/SearchBar/SearchInput"));
var SearchWrapper_1 = __importDefault(require("../atoms/SearchBar/SearchWrapper"));
var SearchBar = function (_a) {
    var searchText = _a.searchText, setSearchText = _a.setSearchText;
    var _b = __read((0, react_1.useState)(!!searchText), 2), isVisible = _b[0], setVisible = _b[1];
    var textInput = react_1.default.createRef();
    (0, react_1.useEffect)(function () {
        var _a;
        (_a = textInput.current) === null || _a === void 0 ? void 0 : _a.focus();
    });
    var handleClick = function () {
        setSearchText('');
        setVisible(false);
    };
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", alignItems: "center", height: "100%", mx: 0.5 }, { children: [(0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ size: "small", color: "neutral", onClick: function () { return setVisible(true); }, sx: isVisible ? utils_1.visuallyHidden : null, icon: faSearch_1.faSearch, tabIndex: isVisible ? -1 : 0 }, { children: "Search" })), (0, jsx_runtime_1.jsxs)(SearchWrapper_1.default, __assign({ isVisible: isVisible }, { children: [(0, jsx_runtime_1.jsx)(SmallIcon_1.default, { icon: faSearch_1.faSearch, sx: { mr: 0.75 } }), (0, jsx_runtime_1.jsx)(SearchInput_1.default, { placeholder: "Type to search...", autoFocus: isVisible, value: searchText, onChange: function (e) { return setSearchText(e.currentTarget.value); }, onBlur: !searchText ? handleClick : undefined, inputRef: textInput, tabIndex: isVisible ? 0 : -1 }), (0, jsx_runtime_1.jsx)(ClearButton_1.default, { visible: !(0, react_redux_firebase_1.isEmpty)(searchText), onClick: handleClick })] }))] })));
};
exports.default = SearchBar;
